import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import {
  ADD_PACKAGE,
  DELETE_PACKAGE,
  GET_PACKAGES,
  GET_WITHOUT_PERMISSION_PACKAGES,
  UPDATE_PACKAGE,
  UPDATE_PACKAGE_STATUS,
} from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addPackage = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("package/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_PACKAGE, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);
        Swal.fire({
          title: "warning!",
          text: res.data.message,
          icon: "warning",
        });
      }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // const errorMessage =
    //   err.response?.data?.message || "An unexpected error occurred";
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
export const getPackage = () => async (dispatch) => {
  try {
    const res = await axios.get("package/all");
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_PACKAGES, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
// export const getPackageWithoutPermission = () => async (dispatch) => {
//   try {
//     const res = await axios.get("package/permission/without-permission/all");
//     // console.log("state :", res.data);
//     if (res.data.code === 1) {
//       dispatch({
//         type: GET_WITHOUT_PERMISSION_PACKAGES,
//         payload: res.data.data,
//       });
//     }
//   } catch (err) {
//     dispatch(setAlert(err.message, "danger"));
//   }
// };

export const updatePackage = (formData) => async (dispatch) => {
  try {
    // const updatedFormData = {
    //   id: formData.id,
    //   ...(formData.name && { name: formData.name }),
    //   ...(formData.description && { description: formData.description }),
    //   ...(formData.grossAmt && { grossAmt: formData.grossAmt }),
    //   ...(formData.discPer && { discPer: formData.discPer }),
    //   ...(formData.discAmt && { discAmt: formData.discAmt }),
    //   ...(formData.amcPeriod && { amcPeriod: formData.amcPeriod }),
    //   ...(formData.amcPrice && { amcPrice: formData.amcPrice }),
    //   ...(formData.businessType && { businessType: formData.businessType }),
    //   ...(formData.detail && { detail: formData.detail }),
    //   ...(formData.isDemo && { isDemo: formData.isDemo }),
    //   ...(Array.isArray(formData.product) && { product: formData.product }),
    //   ...(formData.status !== undefined && { status: formData.status }),
    // };

    const res = await axios.post("package/update", formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_PACKAGE, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updatePackageStatus = (formData) => async (dispatch) => {
  try {
    const updatedFormData = {
      id: formData.id,
      ...(formData.status !== undefined && { status: formData.status }),
    };

    const res = await axios.post("package/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_PACKAGE_STATUS, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deletePackage = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`package/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_PACKAGE, payload: { id } });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
